module.exports = __webpack_public_path__ + "media/auto_history/thief-b7006301.png";